import React, { FC } from "react";
import { JobPostEditorSectionLayout } from "@components/Layout/JobPostEditorSectionLayout";
import { useFormContext } from "react-hook-form";
import { Input } from "@components/Form/Input";

interface Props {
  isLast?: boolean;
}

export const ApplySection: FC<Props> = ({ isLast }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <JobPostEditorSectionLayout
      title="How to Apply"
      description="Link where to redirect the applicants."
      isLast={isLast}
    >
      <div className="">
        <Input
          label="URL"
          path="jobPost.applyUrl"
          register={register}
          errors={errors}
        />
      </div>
    </JobPostEditorSectionLayout>
  );
};
